// Ticks a live "elapsed since start" label for active device sessions. Reads
// an ISO8601 timestamp from `data-start-time` and updates the element's text
// every second. Ended sessions render a static server-side duration instead, so
// this hook is only attached while a session is active.
function format(seconds) {
  if (seconds < 0) seconds = 0;
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}

export const ElapsedTime = {
  mounted() {
    this.render();
    this.timer = setInterval(() => this.render(), 1000);
  },
  updated() {
    this.render();
  },
  destroyed() {
    if (this.timer) clearInterval(this.timer);
  },
  render() {
    const start = this.el.getAttribute("data-start-time");
    if (!start) return;
    const elapsed = (Date.now() - new Date(start).getTime()) / 1000;
    this.el.textContent = format(elapsed);
  },
};
